module.exports = __webpack_public_path__ + "static/img/v75DetailImg.79dbc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v75DetailImg.png
// module id = B3VD
// module chunks = 1